export { TagStatusColor, TagStatusComponent } from './tag-status.component';
